import { isEmpty } from 'lodash-es'
import { PayInV3Request, PaymentsCreateRequest } from 'types/payments'

/**
 * Maps the payment link form payload onto the v3 pay-in body.
 *
 * The amount the payer is charged is denominated in the form's display currency, so both go in
 * `checkout` along with the optional return url; `beneficiary` only names the receiving wallet and
 * the currency that wallet settles in, which is left out when the wallet's own currency is unknown
 * — the display currency is not a substitute for it. The contact is identified by an
 * `originator.entity` rather than by `complianceDetails`, which is only sent when it still holds
 * details of its own (an unsaved contact's party details). `originator` is sent even when empty —
 * the API rejects a null one, and the payer still picks their crypto currency and network on the
 * hosted payment page.
 */
export const paymentPayloadToPayIn = (
  {
    walletId,
    currency,
    amount,
    returnUrl,
    reference,
    flow,
    expiryMinutes,
    customerId,
    complianceDetails,
  }: PaymentsCreateRequest,
  beneficiaryCurrency?: string
): PayInV3Request => {
  const { contactId, ...remainingComplianceDetails } = complianceDetails ?? {}

  return {
    reference,
    originator: {
      ...(contactId && { entity: { type: 'CONTACT', id: contactId } }),
    },
    beneficiary: {
      ...(walletId && { walletId }),
      ...(beneficiaryCurrency && { currency: beneficiaryCurrency }),
    },
    flow: flow?.toLowerCase(),
    expiryDuration: `PT${expiryMinutes}M`,
    checkout: {
      amount,
      currency,
      ...(returnUrl && { returnUrl }),
    },
    ...(customerId && { customerId }),
    ...(!isEmpty(remainingComplianceDetails) && {
      complianceDetails: remainingComplianceDetails,
    }),
  }
}
